/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { IDimension } from './dimension.js';

export class Size2D {

	constructor(
		public readonly width: number,
		public readonly height: number,
	) { }

	public toString() {
		return `(${this.width},${this.height})`;
	}

	public transpose(): Size2D {
		return new Size2D(this.height, this.width);
	}

	public toDimension(): IDimension {
		return { width: this.width, height: this.height };
	}
}
